export default {
  infoBlockTitle: {
    id: 'bo_sellers-orders-drawers-export_csv_file-all_orders-info_text',
    defaultMessage:
      'Once exported, you can find this file in the File Library.',
  },
} as const
